import {
	FETCH_ALL_CLINICS_REQUEST,
	FETCH_ALL_CLINICS_SUCCESS,
	FETCH_ALL_CLINICS_FAILURE
} from "../../../constants"

const initialState = {
	loading: false,
	data: null,
	error: null,
}

const getClinicsReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ALL_CLINICS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
			};
		case FETCH_ALL_CLINICS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			}
		case FETCH_ALL_CLINICS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null
			}
		default:
			return state;
	}
}
export default getClinicsReducer